@if (initialized) {
  <app-global-layout>
    <router-outlet />
  </app-global-layout>

  <!-- overlays/ modals/ toasts/ notifications etc. -->
  <ag1-toast-notification class="relative z-50" />
  <p-confirmdialog />
  <p-toast />
  <ag-notifications-and-alerts />
  <ag-discard-confirmation-modal
    [(visible)]="discardService.visible"
    [title]="discardService.title()"
    [body]="discardService.body()"
    (confirmed)="discardService.confirm()"
    (cancelled)="discardService.cancel()"
  />
}
<ng-template agModalHost />
